import { createContext, useContext } from 'react';
import { useCookieConsent } from '../../hooks/useCookieConsent';
import { CookieBanner } from './CookieBanner';
import { CookiePreferencesModal } from './CookiePreferencesModal';

interface CookieConsentContextValue {
  openPreferences: () => void;
}

const CookieConsentContext = createContext<CookieConsentContextValue>({
  openPreferences: () => {},
});

export function useCookieConsentContext() {
  return useContext(CookieConsentContext);
}

interface CookieConsentManagerProps {
  children: React.ReactNode;
}

export function CookieConsentManager({ children }: CookieConsentManagerProps) {
  const {
    showBanner,
    showPreferences,
    preferences,
    acceptAll,
    refuseAll,
    saveCustomPreferences,
    openPreferences,
    closePreferences,
  } = useCookieConsent();

  return (
    <CookieConsentContext.Provider value={{ openPreferences }}>
      {children}

      {showBanner && (
        <CookieBanner
          onAccept={acceptAll}
          onRefuse={refuseAll}
          onCustomize={openPreferences}
        />
      )}

      <CookiePreferencesModal
        isOpen={showPreferences}
        currentPreferences={preferences}
        onSave={saveCustomPreferences}
        onAcceptAll={acceptAll}
        onRefuseAll={refuseAll}
        onClose={closePreferences}
      />
    </CookieConsentContext.Provider>
  );
}
